import { useContext } from 'react';
import { BasketType } from '../../../../models/basket-type';
import guestDeleteLineItem from '../../../../services/content-api/endpoints/basket/guest/delete-line-item';
import memberDeleteLineItem from '../../../../services/content-api/endpoints/basket/member/delete-line-item';
import useGetSessionId from '../../user/hooks/use-get-session-id.hook';
import { UserStateContext } from '../../user/user.provider';
import basketLoading from '../actions/basket-loading';
import updateBasket from '../actions/update-basket';
import { BasketDispatchContext, BasketStateContext } from '../basket.provider';

const useDeleteBasketLineItem: () => (
  lineItemId: number
) => Promise<BasketType> = () => {
  const { auth } = useContext(UserStateContext);
  const basketState = useContext(BasketStateContext);
  const basketDispatch = useContext(BasketDispatchContext);
  const getSessionId = useGetSessionId();

  return async (lineItemId) => {
    basketDispatch(basketLoading(true));

    let basket: BasketType;
    try {
      basket = auth.accessToken
        ? await memberDeleteLineItem(
            lineItemId,
            await getSessionId(),
            basketState.id
          )
        : await guestDeleteLineItem(
            lineItemId,
            await getSessionId(),
            basketState.id
          );
    } catch (error) {
      basketDispatch(basketLoading(false));
      throw error;
    }

    basketDispatch(updateBasket(basket));
    basketDispatch(basketLoading(false));

    return basket;
  };
};

export default useDeleteBasketLineItem;
